import React, { useEffect, useState } from 'react';
import PayrollLayout from '../../layouts/PayrollLayout';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default function StatutoryCompliance() {
  const [reports, setReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);
  const [search, setSearch] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const dummy = [
        {
          id: 1,
          type: 'EPF Contribution',
          month: 'April',
          year: '2024',
          date: '2024-04-10',
          download_url: '#',
        },
        {
          id: 2,
          type: 'ESI Payment',
          month: 'May',
          year: '2024',
          date: '2024-05-05',
          download_url: '#',
        },
        {
          id: 3,
          type: 'Professional Tax',
          month: 'April',
          year: '2024',
          date: '2024-04-15',
          download_url: '#',
        },
      ];
      setReports(dummy);
      setFilteredReports(dummy);
      setLoading(false);
    }, 1000);
  }, []);

  const filterReports = (searchText, selectedMonth, selectedYear, start, end) => {
    const filtered = reports.filter((r) => {
      const matchesSearch = r.type.toLowerCase().includes(searchText);
      const matchesMonth = selectedMonth ? r.month === selectedMonth : true;
      const matchesYear = selectedYear ? r.year === selectedYear : true;
      const matchesDate =
        (!start || new Date(r.date) >= new Date(start)) &&
        (!end || new Date(r.date) <= new Date(end));
      return matchesSearch && matchesMonth && matchesYear && matchesDate;
    });
    setFilteredReports(filtered);
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    filterReports(value, month, year, startDate, endDate);
  };

  const handleMonthChange = (e) => {
    const value = e.target.value;
    setMonth(value);
    filterReports(search, value, year, startDate, endDate);
  };

  const handleYearChange = (e) => {
    const value = e.target.value;
    setYear(value);
    filterReports(search, month, value, startDate, endDate);
  };

  const handleDateChange = (field, value) => {
    if (field === 'start') setStartDate(value);
    else setEndDate(value);
    filterReports(search, month, year, field === 'start' ? value : startDate, field === 'end' ? value : endDate);
  };

  const handleExportCSV = () => {
    const headers = ['Type', 'Month', 'Year', 'Date', 'Download URL'];
    const rows = filteredReports.map((r) => [
      r.type,
      r.month,
      r.year,
      r.date,
      r.download_url,
    ]);
    const csvContent = [headers, ...rows].map((row) => row.join(',')).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'statutory_compliance.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportPDF = () => {
    const doc = new jsPDF();
    autoTable(doc, {
      head: [['Type', 'Month', 'Year', 'Date']],
      body: filteredReports.map((r) => [r.type, r.month, r.year, r.date]),
    });
    doc.save('statutory_compliance.pdf');
  };

  const handleDownloadAllZip = () => {
    alert('Download ZIP feature coming soon!');
  };

  const handleEmailFinance = () => {
    alert('Email has been sent to finance@example.com (mock)');
  };

  return (
    <PayrollLayout title="Statutory Compliance">
      <div className="bg-white dark:bg-gray-900 font-poppins p-4 rounded-2xl space-y-4 mx-2 md:mx-0">
        <div className="flex flex-col md:flex-wrap lg:flex-nowrap lg:flex-row gap-2 justify-between">
          <div className="flex flex-wrap gap-2">
            <input
              type="text"
              placeholder="Search report type..."
              value={search}
              onChange={handleSearch}
              className="border dark:bg-black dark:text-white dark:border-gray-700 px-3 py-2 rounded text-sm w-full md:w-auto"
            />
            <select onChange={handleMonthChange} value={month} className="border dark:bg-black dark:text-white dark:border-gray-700 px-3 py-2 rounded text-sm">
              <option value="">All Months</option>
              {['January','February','March','April','May','June','July','August','September','October','November','December'].map((m) => (
                <option key={m} value={m}>{m}</option>
              ))}
            </select>
            <select onChange={handleYearChange} value={year} className="border dark:bg-black dark:text-white dark:border-gray-700 px-3 py-2 rounded text-sm">
              <option value="">All Years</option>
              {['2022', '2023', '2024'].map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
            <input
              type="date"
              value={startDate}
              onChange={(e) => handleDateChange('start', e.target.value)}
              className="border dark:bg-black dark:text-white dark:border-gray-700 px-3 py-2 rounded text-sm"
            />
            <input
              type="date"
              value={endDate}
              onChange={(e) => handleDateChange('end', e.target.value)}
              className="border dark:bg-black dark:text-white dark:border-gray-700 px-3 py-2 rounded text-sm"
            />
          </div>
          <div className="flex flex-wrap gap-2">
            <button onClick={handleExportCSV} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm">Export CSV</button>
            <button onClick={handleExportPDF} className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded text-sm">Export PDF</button>
            <button onClick={handleDownloadAllZip} className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm">Download ZIP</button>
            <button onClick={handleEmailFinance} className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded text-sm">Email Finance</button>
          </div>
        </div>

        <div className="overflow-x-auto bg-white dark:bg-gray-900 shadow-md rounded-lg">
          <table className="min-w-full table-auto md:table-fixed text-sm">
            <thead className="bg-gray-100 dark:bg-gray-800 dark:text-white">
              <tr>
                <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Report Type</th>
                <th className="py-2 px-4 dark:text-white text-left font-semibold text-xs md:text-sm text-black whitespace-nowrap">Date</th>
                <th className="py-2 px-4 dark:text-white text-center font-semibold text-xs md:text-sm text-black whitespace-nowrap">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {loading ? (
                <tr className="border-b hover:bg-gray-100 dark:hover:bg-gray-800">
                  <td colSpan="6" className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                    <div className="animate-spin h-6 w-6 border-2 border-blue-500 border-t-transparent rounded-full mx-auto mb-2 mt-2"></div>
                    {/* <p className="text-sm text-center text-gray-500">Loading reports...</p> */}
                  </td>
                </tr>
              ) : filteredReports.length > 0 ? (
                filteredReports.map((r) => (
                  <tr key={r.id} className="dark:border-gray-700 dark:hover:bg-gray-950 dark:hover:text-white dark:text-white">
                    <td className="py-2 px-4 text-xs dark:text-white md:text-sm whitespace-nowrap">{r.type}</td>
                    <td className="py-2 px-4 text-xs dark:text-white md:text-sm whitespace-nowrap">{r.month}, {r.year} — {r.date}</td>
                    <td className="py-2 px-4 text-xs dark:text-white text-center md:text-sm whitespace-nowrap">
                      <a
                        // href={r.download_url}
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 hover:underline hover:underline-offset-4 text-sm"
                      >
                        Download
                      </a>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="py-4 px-4 text-center text-gray-500">
                    No reports found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </PayrollLayout>
  );
}
